var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      width: 25,
      height: 25
    },
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6DC6ADC6-DEA5-4824-8CF6-12683F94F9E0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.4674286,6.54563265 L13.5657143,6.18906122 C13.4501224,5.80440816 13.2986122,5.43542857 13.1108571,5.08832653 L14.2112653,3.4795102 C14.3131429,3.33061224 14.2919184,3.10661224 14.1642449,2.97926531 L12.8075102,1.62220408 C12.6798367,1.49453061 12.4561633,1.47395918 12.3079184,1.5755102 L10.6981224,2.67657143 C10.340898,2.48391837 9.9604898,2.32946939 9.5637551,2.21289796 L9.20914286,0.320979592 C9.17583673,0.143673469 9.00342857,0 8.82253061,0 L6.90383673,0 C6.72326531,0 6.55053061,0.143673469 6.51689796,0.320979592 L6.15836735,2.2315102 C5.77795918,2.3477551 5.41322449,2.49926531 5.06971429,2.68604082 L3.48081633,1.59902041 C3.33191837,1.49714286 3.10791837,1.51804082 2.98057143,1.64571429 L1.6235102,3.00277551 C1.49583673,3.13044898 1.47526531,3.35412245 1.57681633,3.50302041 L2.67069388,5.10171429 C2.48653061,5.44522449 2.33730612,5.80963265 2.22302041,6.18938776 L0.321306122,6.54563265 C0.144326531,6.57926531 0.000653061224,6.752 0.000653061224,6.93257143 L0.000653061224,8.85126531 C0.000653061224,9.03183673 0.144326531,9.20457143 0.321306122,9.23853061 L2.22171429,9.59477551 C2.33763265,9.98269388 2.49044898,10.3549388 2.67918367,10.7046531 L1.59771429,12.2857143 C1.49583673,12.4346122 1.51673469,12.6586122 1.64440816,12.7856327 L3.00114286,14.1423673 C3.12881633,14.2703673 3.3524898,14.2906122 3.50138776,14.1897143 L5.08179592,13.1079184 C5.42171429,13.2917551 5.78253061,13.4413061 6.15902041,13.556898 L6.51722449,15.4680816 C6.55085714,15.6453878 6.72359184,15.7884082 6.90416327,15.7884082 L8.82318367,15.7884082 C9.00408163,15.7884082 9.17616327,15.6453878 9.21012245,15.4680816 L9.56506122,13.5758367 C9.95689796,13.4602449 10.3337143,13.3077551 10.6876735,13.1183673 L12.288,14.213551 C12.436898,14.3154286 12.660898,14.2945306 12.7882449,14.1662041 L14.1443265,12.8101224 C14.2726531,12.6821224 14.292898,12.459102 14.1916735,12.3098776 L13.1026939,10.7186939 C13.2950204,10.3647347 13.4494694,9.9882449 13.5673469,9.59542857 L15.4674286,9.23918367 C15.6440816,9.20522449 15.7874286,9.0324898 15.7874286,8.85191837 L15.7874286,6.93322449 C15.7887347,6.752 15.6447347,6.57926531 15.4674286,6.54563265 Z M7.89485714,11.1872653 C6.07673469,11.1872653 4.60244898,9.71297959 4.60244898,7.89387755 C4.60244898,6.07608163 6.07673469,4.60146939 7.89485714,4.60146939 C9.71363265,4.60146939 11.1882449,6.07608163 11.1882449,7.89387755 C11.1882449,9.71297959 9.71297959,11.1872653 7.89485714,11.1872653 Z",
    id: "path-nut"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16E55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ver-Perfil-Supervisor",
    transform: "translate(-862.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-&-NavBar"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(862.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-[6h]"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nut-icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-nut",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-nut"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Icon-Color",
    mask: "url(#mask-nut)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 15.6734695,
    height: 15.6734695
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutIcon);
export default __webpack_public_path__ + "static/media/nut-icon.699a3122117fa3341f4a3b29feea44ca.svg";
export { ForwardRef as ReactComponent };